import { pageMetaTypes } from '../config/pages';

export enum verifyRouteResponse {
  /**
   * User can stay on the current page.
   */
  allowed = 'allowed',
  /**
   * Redirect to the login page (unauthenticated user on a private page).
   */
  login = 'login',
  /**
   * Redirect to the partner dashboard (authenticated user on a session page).
   */
  dashboard = 'dashboard',
}

/**
 * Pure routing guard used by the session gate. It mirrors the legacy
 * `redirectSession` behaviour without side effects so it can be unit tested.
 *
 * - Public pages are always allowed.
 * - Session pages (login, welcome, set-password) redirect logged users to the dashboard.
 * - Private pages (the default) redirect unauthenticated users to the login page.
 */
export const verifyRoute = (
  type: pageMetaTypes | undefined,
  isLogged: boolean,
): verifyRouteResponse => {
  if (type === pageMetaTypes.public) {
    return verifyRouteResponse.allowed;
  }

  if (type === pageMetaTypes.session) {
    return isLogged ? verifyRouteResponse.dashboard : verifyRouteResponse.allowed;
  }

  return isLogged ? verifyRouteResponse.allowed : verifyRouteResponse.login;
};
